import { FieldType, WebsitePublicationField } from '../../../../components/GenericSection';
export var ONLINE_PUBINFO_SECTION_FIELDS = [{
  field: WebsitePublicationField.TITLE,
  labelText: 'Website title',
  recommended: true,
  type: FieldType.TEXT
}, {
  field: WebsitePublicationField.PUBLISHER,
  labelText: 'Publisher/sponsor',
  type: FieldType.TEXT
}, {
  field: WebsitePublicationField.URL,
  labelText: 'URL',
  recommended: true,
  type: FieldType.TEXT
}, {
  type: FieldType.RADIO,
  labelText: 'Display URL?',
  options: [{
    key: 'yes',
    value: 'Yes'
  }, {
    key: 'no',
    value: 'No'
  }],
  defaultSelectedIndex: 1,
  field: WebsitePublicationField.DISPLAY_URL,
  alignment: 'horizontal'
}, {
  type: FieldType.PUBDATE,
  labelText: 'Electronically published',
  field: WebsitePublicationField.ELEC_PUB_DATE,
  formikFieldNames: ['day', 'month', 'year']
}, {
  type: FieldType.PUBDATE,
  labelText: 'Date accessed',
  field: WebsitePublicationField.DATE_ACCESSED,
  formikFieldNames: ['dayaccessed', 'monthaccessed', 'yearaccessed']
}];